import React, {forwardRef, useEffect, useId, useImperativeHandle, useRef} from 'react';
import _ from 'lodash';
import {Button} from "../../../../components/Button";
import "./CoverFromUpload.scss";
import useUpload from "../../../../../hooks/useUpload";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {MEDIA_KEY, MEDIAS_KEY, updateCoverVideoFile} from "../../../../../api/public-voissa/medias";
import {toastError} from "../../../../../libs/toast";
import {MEDIA} from "../../../../../const/toasts";


const CoverFromUpload = forwardRef(({
         mediaId = null,
         uploadPath = "/medias/upload-cover-video",
         handleClose = () =>{}
     }, ref) =>{

    let refUploadInput = useRef();
    const queryClient = useQueryClient();
    const idInput = useId();

    const {data : dataUploads, uploads, resetUpload} = useUpload(uploadPath);

    const {
        mutate : mutateUpdateMedia,
    } = useMutation((data) => updateCoverVideoFile(mediaId, data),{
        onSuccess: async () =>{
            await queryClient.invalidateQueries([MEDIAS_KEY]);
            await queryClient.invalidateQueries([MEDIA_KEY, mediaId]);
        },
        onError: () =>{
            toastError(MEDIA.ERROR.UPDATE);
        }
    });

    useImperativeHandle(ref, () => ({
        cleanUpload() {
            resetUpload();
        }
    }));

    function handleSubmit(){
        mutateUpdateMedia({fileId : dataUploads.res._id});
        handleClose();
    }

    async function handleFiles(){
        let newFiles = refUploadInput.current.files;
        await uploads(newFiles);
        refUploadInput.current.value = "";
    }

    useEffect(() =>{
        if(refUploadInput?.current){
            refUploadInput.current.click();
        }
    }, []);

    return (
     <div id={"cover-from-upload"}>
        <div id={"uploads"} className={"modal-container"}>

            <div className={"modal-body"}>
                {dataUploads.preview &&
                    <div className={"img-preview-container"}>
                        <img alt={""} className={`img-preview`} src={dataUploads.preview} />
                    </div>
                }
                <input type="file"
                       id={idInput}
                       style={{display:'none'}}
                       accept="image/jpeg, image/png"
                       disabled={dataUploads.isLoading}
                       ref={refUploadInput}
                       onChange={(file)=> handleFiles(file) }
                />

                <label htmlFor={idInput} className={"upload-input-btn"}>
                    <div className="btn white"
                         style={{background: `linear-gradient(to right,#51a9fd ${dataUploads.uploadProgress.percentCompleted}%,#1F7DEC ${dataUploads.uploadProgress.percentCompleted}%)`}}
                    >
                        {dataUploads.isLoading ? _.truncate(dataUploads.name, {length : 25}) : 'Choisissez un fichier'}
                    </div>
                </label>

            </div>
            <div className={"modal-baseline2"}>
                {dataUploads.isError && <span className={"warning upload-error-message"}>{dataUploads.error}</span>}

                <Button btnStyle={"grey"}
                        size={"small"}
                        onClick={()=>handleClose()}
                        content={"Annuler"}/>

                {dataUploads.isSuccess && (
                    <Button btnStyle={"primary-reverse"}
                            size={"small"}
                            className={"ml-8"}
                            onClick={()=>handleSubmit()}
                            content={"Utiliser cette image en couverture"}/>
                )}
            </div>
        </div>
    </div>
    );
});

export default CoverFromUpload;